import {useEffect, useRef, useState} from "react";
import {PolTextLogo} from "@/components/logo";

export default function Splash({show = false, time = 1000, timestamp = 100}) {

    const timerRef = useRef(null);
    const roundedPercentage = useRef(null);

    const [hide, setHide] = useState(!show);

    useEffect(() => {

        let count = 0;
        let percentage = 0;
        const interval = setInterval(() => {
            percentage = ~~((timestamp * count) / time * 100);
            timerRef.current.innerText = `${percentage}`;
            roundedPercentage.current.style.width = `${percentage}%`

            if(percentage >= 100) {
                clearInterval(interval);
                setHide(true)
            } else {
                count++;
            }
        }, timestamp);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div className={`fixed bg-white flex-center top-0 left-0 z-[9999] duration-200 ${hide ? "opacity-0 pointer-events-none w-0 h-0" : "w-screen h-screen"}`}>
            <div className="flex flex-col items-center">
                <PolTextLogo />
                <div className="relative w-[15rem] rounded-xl bg-pol-gray-300 h-2 mt-10">
                    <span ref={roundedPercentage} className="absolute right-0 bg-pol-blue rounded-xl duration-300 h-full" style={{width: "0%"}} />
                </div>
                <p className="mt-4">در حال بارگذاری <span ref={timerRef} className="min-w-[100px]">0</span>%</p>
            </div>
        </div>
    )
};
